import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { isMobileOnly } from 'react-device-detect'

import Dashboard from 'app/domains/routes/Dashboard'
import Profile from 'app/domains/routes/Profile'
import FavoriteActivities from 'app/domains/routes/FavoriteActivities'
import CompletedProtracks from 'app/domains/routes/CompletedProTracks'
import DifferentActivity from 'app/domains/routes/DifferentActivity'
import Start from 'app/domains/routes/Start'
import NotFound from 'app/components/NotFound/NotFound'
import SafeRoute from 'app/components/SafeRoute'

import SelectProtrack from 'app/domains/routes/OnBoarding/OnBoardingSelectProtrack'
import OnboardingLanding from 'app/domains/routes/OnBoarding/OnBoardingLanding'
import Notifications from 'app/domains/routes/Notifications'
import Stories from 'app/domains/routes/Stories'
import GlobalLoaderOrSpinner from 'app/components/Loaders/GlobalLoaderOrSpinner'
import OnboardingChecklist from 'app/domains/routes/Dashboard/OnboardingChecklist'
import { MAX_TABLET_DEVICE_WIDTH } from 'app/constants/screenSizes'

const UserRouter = ({
  isStageIsSelection,
  isTranslationsLoadedForDashboardPage,
  windowWidth,
  isUserEverTakeProTrack,
}) => {
  const accessToOnboardingLanding = !isUserEverTakeProTrack
  const isMobile = windowWidth <= MAX_TABLET_DEVICE_WIDTH
  return isTranslationsLoadedForDashboardPage ? (
    <>
      {!accessToOnboardingLanding && !isMobile && <OnboardingChecklist />}
      <Switch>
        <Redirect from="/login" to={accessToOnboardingLanding ? '/on-boarding-landing' : '/dashboard'} />
        <Redirect from="/" to={accessToOnboardingLanding ? '/on-boarding-landing' : '/dashboard'} exact />
        <SafeRoute exact path="/on-boarding-landing" component={OnboardingLanding} access={accessToOnboardingLanding} />
        <Route path="/dashboard" component={Dashboard} />
        <SafeRoute
          path="/profile"
          component={Profile}
          redirect="/on-boarding-landing"
          access={!accessToOnboardingLanding}
        />
        <SafeRoute
          path="/favorite-activities"
          component={FavoriteActivities}
          redirect="/on-boarding-landing"
          access={!accessToOnboardingLanding}
        />
        <SafeRoute
          path="/completed-pro-tracks"
          component={CompletedProtracks}
          redirect="/on-boarding-landing"
          access={!accessToOnboardingLanding}
        />
        <SafeRoute
          path="/different-activity"
          component={DifferentActivity}
          redirect="/on-boarding-landing"
          access={!accessToOnboardingLanding}
        />
        <SafeRoute
          path="/select-protrack"
          component={SelectProtrack}
          redirect="/dashboard"
          access={!accessToOnboardingLanding && isStageIsSelection}
        />
        <SafeRoute
          path="/stories"
          component={Stories}
          redirect="/on-boarding-landing"
          access={!accessToOnboardingLanding}
        />
        <SafeRoute path="/notifications" component={Notifications} redirect="/dashboard" access={isMobileOnly} />
        <Route path="/start" component={Start} />
        <Route component={NotFound} />
      </Switch>
    </>
  ) : (
    <GlobalLoaderOrSpinner />
  )
}

UserRouter.displayName = 'UserRouter'

export default UserRouter
